var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SwoopSearchResults"},[_c('SidebarHeader',{attrs:{"title":"Search tickets","button":"New ticket","options":['Open', 'Closed']},on:{"new":function($event){return _vm.$router.push('/support/new')}}}),_c('q-infinite-scroll',{ref:"infinityScroll",attrs:{"offset":250},on:{"load":_vm.loadMoreTickets},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('div',{staticClass:"row justify-center q-my-md"},[_c('q-spinner-dots',{attrs:{"color":"primary","size":"40px"}})],1)]},proxy:true}])},_vm._l((_vm.records),function(record){return _c('SearchResult',{key:record.id,attrs:{"to":("/support/" + (record.id)),"title":record.name,"subtitle":record.workflow.name,"status":record.status,"status-color":_vm.statusColor(record.status),"bar":0,"details":[
        {
          icon: 'o_dns',
          boldText:
            (record.parent === 'Service_Location'
              ? 'Location'
              : record.parent) + ': ',
          text: record.ticket_parent
            ? record.ticket_parent.name
            : record.parent_id
        },
        { icon: 'schedule', text: _vm.dateCreated(record) }
      ]}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }